exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".address-label{font-size:12px}.address-category-container{padding-left:5px;padding-right:5px}@media(max-width: 767px){.address-row{flex-wrap:wrap}.address-category-row{flex-wrap:nowrap}.address-row .address-label{flex:0 0 100%;max-width:100%;text-align:left !important}.address-row .col-6{flex:1 1 0;max-width:none}.address-spacer{display:none}.address-row .col-1{flex:0 0 auto;width:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/forms/AddressForm/styles.scss
// module id = 763
// module chunks = 0